import type { Story } from "@/react/story/types";
import { createContext, type CSSProperties, useContext } from "react";

type Context = {
    story: Story;
    patch: (key: string, value: unknown) => Promise<void>;
    getViewerStyle: () => CSSProperties;
}

export const StoryContext = createContext<Context>({} as Context);

export const useStory = () => useContext(StoryContext);
